import React, { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MaxWidthWrapperProps {
  children: ReactNode;
  className?: string;
}

const MaxWidthWrapper: React.FC<MaxWidthWrapperProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        "mx-auto w-full  px-4 sm:px-6 lg:px-8 py-2",
        className
      )}
    >
      {children}
    </div>
  );
};

export default MaxWidthWrapper;
